var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0013 6.70832C6.61453 6.70832 6.2436 6.55468 5.9701 6.28119C5.69661 6.0077 5.54297 5.63676 5.54297 5.24999C5.54297 4.86322 5.69661 4.49228 5.9701 4.21879C6.2436 3.9453 6.61453 3.79166 7.0013 3.79166C7.38808 3.79166 7.75901 3.9453 8.0325 4.21879C8.30599 4.49228 8.45964 4.86322 8.45964 5.24999C8.45964 5.4415 8.42191 5.63114 8.34863 5.80807C8.27534 5.985 8.16792 6.14577 8.0325 6.28119C7.89708 6.41661 7.73632 6.52403 7.55938 6.59731C7.38245 6.6706 7.19281 6.70832 7.0013 6.70832ZM7.0013 1.16666C5.91833 1.16666 4.87972 1.59686 4.11395 2.36264C3.34818 3.12841 2.91797 4.16702 2.91797 5.24999C2.91797 8.31249 7.0013 12.8333 7.0013 12.8333C7.0013 12.8333 11.0846 8.31249 11.0846 5.24999C11.0846 4.16702 10.6544 3.12841 9.88865 2.36264C9.12288 1.59686 8.08427 1.16666 7.0013 1.16666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.213de3364f5195ead1ef18b9efc2cae2.svg";
export { ForwardRef as ReactComponent };